import { Controller } from "@hotwired/stimulus"

// Mobile admin menu toggle.
export default class extends Controller {
  static targets = ["nav"]

  toggle() {
    jQuery(this.navTarget).slideToggle()
    this.element.classList.toggle('active')
  }
}
